import styled from "styled-components";
export const Container = styled.div<{ $padding?: string | number }>`
  flex: 1;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
`;
export const FullContainer = styled(Container)`
  position: absolute;
`;
export const RangeContainer = styled(Container)`
  padding: 20px;
`;
export const ScrollContainer = styled(Container)`
  overflow: auto;
  overflow: overlay;
`;
export default styled(RangeContainer)`
  display: flex;
  flex-direction: column;
  background: #fff;
  gap: 8px;
`;
